var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.61133L7.45467 11.3887L10 8.278",
    stroke: "#034DC5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 4.16667C10.6668 3.81304 10.5264 3.47391 10.2763 3.22386C10.0263 2.97381 9.68712 2.83333 9.3335 2.83333C9.3335 2.47971 9.19302 2.14057 8.94297 1.89052C8.69292 1.64048 8.35378 1.5 8.00016 1.5C7.64654 1.5 7.3074 1.64048 7.05735 1.89052C6.80731 2.14057 6.66683 2.47971 6.66683 2.83333C6.31321 2.83333 5.97407 2.97381 5.72402 3.22386C5.47397 3.47391 5.3335 3.81304 5.3335 4.16667V4.83333H10.6668V4.16667Z",
    stroke: "#034DC5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.5H12.3333C12.5101 3.5 12.6797 3.57024 12.8047 3.69526C12.9298 3.82029 13 3.98986 13 4.16667V14.1667C13 14.3435 12.9298 14.513 12.8047 14.6381C12.6797 14.7631 12.5101 14.8333 12.3333 14.8333H3.66667C3.48986 14.8333 3.32029 14.7631 3.19526 14.6381C3.07024 14.513 3 14.3435 3 14.1667V4.16667C3 3.98986 3.07024 3.82029 3.19526 3.69526C3.32029 3.57024 3.48986 3.5 3.66667 3.5H4.33333",
    stroke: "#034DC5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.83e277caf01c8243f25132826cf2e08b.svg";
export { ForwardRef as ReactComponent };